import React from 'react';
import { ReactFlow, Controls, Background } from '@xyflow/react';
import KingdomSelector from './Components/KingdomSelector.jsx'
import UnitCardNode from './Components/UnitCardNode.jsx'

import '@xyflow/react/dist/style.css';
import GetFactionTreeAsFlow from './KW/UnitTree.jsx';

const nodeTypes = { unitCard: UnitCardNode };

class App extends React.Component {

  state = {
    selectedFaction: "loargen",
    selectedCharacter: "arnold"
  }

  UpdateSelectedCharacter = (newSelectedFaction, newSelectedCharacter) => {
    this.setState({'selectedFaction': newSelectedFaction, 'selectedCharacter': newSelectedCharacter});
  }

  render()
  {
    let tree = GetFactionTreeAsFlow(this.state.selectedFaction, this.state.selectedCharacter, "unitCard");

    return (
      <div>
        <KingdomSelector characters={tree.characters} selectedCharacter={this.state.selectedCharacter} onKingdomSelected={this.UpdateSelectedCharacter}/>
        <div style={{ width: '1080px', height: '720px' }}>
          <ReactFlow
            nodes={tree.nodes}
            edges={tree.edges}
            nodeTypes={nodeTypes} >
            <Background />
            <Controls />
          </ReactFlow>
        </div>
      </div>
    );
  }
}

export default App;